import React, { useEffect, useState } from "react";
import { Table, message, Button } from "antd";
import { useHistory } from "react-router-dom";
import firebase from "../../../config/FirebaseConfig";
import Layout from "../../../layout/Dashboard";
import './List.css'

export default function PsikologList() {
  const [dataSource, setDataSource] = useState([]);
  const history = useHistory();

  useEffect(() => {
    const fetchData = () => {
      firebase
        .firestore()
        .collection("temp")
        .get()
        .then((snapshot) => {
          let temp = [];
          snapshot.forEach((doc) => {
            temp.push({
              key: doc.id,
              ...doc.data(),
            });
          });
          setDataSource(temp);
        })
        .catch((err) => {
          console.log(err);
          message.error("Ada kesalahan saat mengambil data");
        });
    };

    fetchData();
  }, []);

  function formatDate(date) {
    return (
      date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear()
    );
  }

  const columns = [
    {
      title: "Timestamp",
      dataIndex: "timestamp",
      key: "timestamp",
      render: (date) => {
        return <span>{formatDate(date.toDate())}</span>;
      },
    },
    {
      title: "Nama",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "No HP",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
    },
    {
      title: "Alamat",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "No Identitas",
      dataIndex: "IDCardNumber",
      key: "IDCardNumber",
    },
    {
      title: "Aksi",
      render: (row) => {
        return (
          <Button
            className="button_secondary"
            onClick={() => {
              history.push(`/dashboard/psikolog/${row.key}`);
            }}
          >
            Lihat Detail
          </Button>
        );
      },
    },
  ];

  return (
    <div id="list-psikolog">
      <Layout>
        <div className="header">Psychologist Registration</div>
        <Table columns={columns} dataSource={dataSource} />
      </Layout>
    </div>
  );
}
